// K2-3072/K2-3073: i18n key (uk-UA / en-US) for a payment that may have been
// taken but is not settled on the order yet - never shown as a failure, so the
// customer does not pay twice.
export const PAYMENT_BEING_CHECKED = 'Your payment is being checked. If it is not confirmed soon, please contact support.'

// K2-3073: the one "being checked" notification every iPay flow shows (checkout,
// pay-order modal, OTP confirmation). translate: i18n.t.
export function notifyPaymentBeingChecked (store: { dispatch: (type: string, payload: any) => any }, translate: (key: string) => string = key => key) {
  return store.dispatch('notification/spawnNotification', {
    type: 'warning',
    message: translate(PAYMENT_BEING_CHECKED),
    action1: { label: translate('OK') }
  })
}

// K2-3073: the order is already paid (by an earlier payment) - shown as paid,
// never as a declined payment with a Pay button.
export const ORDER_ALREADY_PAID = 'This order is already paid.'

// K2-3084: vuestorefront-api's own refusals the customer may see (e.g. the 503
// when iPay was never reached - nothing charged, try again). Translated in
// uk-UA / en-US; shown through translatePaymentMessage.
export const PAYMENT_API_MESSAGES = [
  'The payment service is unavailable. Please try again.',
  'The payment service is unavailable',
  'The payment cannot be confirmed right now',
  'The payment cannot be started right now',
  'The payment can no longer be confirmed'
]

// A message from vuestorefront-api or iPay as the customer sees it: the
// translation when there is one, the text as it is otherwise (a non-text
// value is passed on untouched).
export function translatePaymentMessage (message: any, translate: (key: string) => string = key => key): any {
  if (typeof message !== 'string' || !message) {
    return message
  }
  return translate(message)
}

export function notifyOrderAlreadyPaid (store: { dispatch: (type: string, payload: any) => any }, translate: (key: string) => string = key => key) {
  return store.dispatch('notification/spawnNotification', {
    type: 'success',
    message: translate(ORDER_ALREADY_PAID),
    action1: { label: translate('OK') }
  })
}
